import React from "react";
import ButtonTable from "../table/buttonTable";

export function DangerIcon(props) {
    if (!props.visible) return null;
    const estilo = { margin: 0, borderRadius: "0.3rem" };

    if (props.height) estilo.height = props.height;
    if (props.width) estilo.width = props.width;

    return (
        <ButtonTable solid={true} style={estilo} title={props.title} type={props.type || "danger"} icon={"fas fa-exclamation"} visible={true} event={() => ({})}>
            {props.description ? (
                <span style={{ fontSize: "0.8rem" }}>
                    {props.description} <i className="fas fa-exclamation" />
                </span>
            ) : null}
        </ButtonTable>
    );
}
